import { render, staticRenderFns } from "./RoamingDialog.vue?vue&type=template&id=71667609&scoped=true"
import script from "./RoamingDialog.vue?vue&type=script&lang=js"
export * from "./RoamingDialog.vue?vue&type=script&lang=js"
import style0 from "./RoamingDialog.vue?vue&type=style&index=0&id=71667609&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71667609",
  null
  
)

export default component.exports